module.exports = __webpack_public_path__ + "43ec1e39170567983b1f3a8679e5e347.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-19.png
// module id = 1735
// module chunks = 0